import React from 'react';
import { useAuthStore } from 'store/useAuthStore';
import './appTopBar.css';

export type AppView = 'comparison' | 'history' | 'compare' | 'users';

interface AppTopBarProps {
  view: AppView;
  onChangeView: (v: AppView) => void;
}

/** App-level bar: view switch + the logged-in user and a logout control.
 *  Shown above both the Comparison grid and the History view. */
export function AppTopBar({ view, onChangeView }: AppTopBarProps) {
  const user = useAuthStore((s) => s.user);
  const signOut = useAuthStore((s) => s.signOut);
  // The Users (tier management) tab is superuser-only — matches the
  // backend's get_superuser guard (is_superuser OR role admin).
  const isAdmin = !!user && (user.is_superuser || user.role === 'admin');

  return (
    <div className="app-topbar">
      <div className="app-topbar-left">
        <span className="app-brand">NoBrainer</span>
        <nav className="app-tabs">
          <button
            className={`app-tab ${view === 'comparison' ? 'active' : ''}`}
            onClick={() => onChangeView('comparison')}
          >
            Comparison
          </button>
          <button
            className={`app-tab ${view === 'history' ? 'active' : ''}`}
            onClick={() => onChangeView('history')}
          >
            History
          </button>
          {/* Engine comparison reads the same superuser-only /analyses surface
              the History view does, so it is gated the same way. */}
          {isAdmin && (
            <button
              className={`app-tab ${view === 'compare' ? 'active' : ''}`}
              onClick={() => onChangeView('compare')}
              title="Compare engines on identical inputs, using forked analyses"
            >
              Compare
            </button>
          )}
          {isAdmin && (
            <button
              className={`app-tab ${view === 'users' ? 'active' : ''}`}
              onClick={() => onChangeView('users')}
            >
              Users
            </button>
          )}
        </nav>
      </div>
      <div className="app-topbar-right">
        {user && <span className="app-user">{user.username}</span>}
        <button className="app-logout" onClick={() => void signOut()} title="Log out">
          Log out
        </button>
      </div>
    </div>
  );
}
